/**
 * Utility class for handling Tizen app versions.
 */
export default class TizenAppsVersionUtil {
  static getVersionString(version: string | number): string {
    if(typeof version === 'number') {
      return version.toFixed(2);
    } else {
      return version;
    }
  }

  /** Returns negative, zero, or positive — like a standard comparator. */
  static compareVersions(version1: string | number, version2: string | number): number {
    const parts1 = String(version1).split('.').map(Number);
    const parts2 = String(version2).split('.').map(Number);
    const maxLen = Math.max(parts1.length, parts2.length);
    for (let i = 0; i < maxLen; i++) {
      const a = parts1[i] ?? 0;
      const b = parts2[i] ?? 0;
      if (a !== b) return a - b;
    }
    return 0;
  }

  static compare(version1: string | number, version2: string | number): boolean {
    return this.compareVersions(version1, version2) === 0;
  }

  static greaterThan(version1: string | number, version2: string | number): boolean {
    return this.compareVersions(version1, version2) > 0;
  }

  static lessThan(version1: string | number, version2: string | number): boolean {
    return this.compareVersions(version1, version2) < 0;
  }
}
